import { ax } from '../utils/axios/axios'
import { BASE_API_URL } from '../constants'
import { RoleId } from '@src/types/common/RoleId'
import { VMPSiteMap } from '@src/types/VMPSiteMap'

interface Options {
  vmpId: number,
  serialId: number,
}

export const apiVMPSubmit = (options: Options) => {
  const { vmpId, serialId } = options
  const axOptions = {
    method: 'PUT',
    url: `${BASE_API_URL}/v2/vmp/${vmpId}/status/completed`,
    params: {
      reqSid: serialId,
      reqRole: RoleId.ProjectManager,
      reqDev: 'web',
    }
  }
  return ax(axOptions)
}